import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiInteractiveQuoteFormFooter' })(
  ({ brandType, breakpoints, typography }) => ({
    footer: {
      width: 'auto',
      backgroundColor: 'transparent',
      marginBottom: typography.pxToRem(13),
      marginLeft: typography.pxToRem(40),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginBottom: typography.pxToRem(16),
      },
    },
    legal: {
      ...brandType['body-s'],
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['body-xs'],
      },
    },
    link: {
      textDecoration: 'none',
    },
    copyright: {
      ...brandType['body-s'],
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['body-xs'],
      },
    },
  })
);

export default useStyles;
